<template>
    <div class="content">
        <div class="tabs">
            <div class="tab favorites" v-bind:class="{'selected-tab':currentTabIndex === 0}"
                 v-on:click="setTabIndex(0)">
                <div>
                    <span class="tab-content">{{l10nFavorites}}</span>
                </div>
            </div>
            <div class="tab history" v-bind:class="{'selected-tab':currentTabIndex === 1}" v-on:click="setTabIndex(1)">
                <div>
                    <span class="tab-content">{{l10nHistory}}</span>
                </div>
            </div>
        </div>
        <div class="actions">
            <div>
                <span class="remove-all" v-on:click="deleteAllCurrentEvents()">
                    <font-awesome-icon class="remove-all-icon" :icon="['fal', 'trash-alt']"/>
                    <span>{{l10nRemoveAllFromList}}</span>
                </span>
            </div>
            <div>
                <span>{{l10nDownloadAll}}</span>
            </div>
        </div>
        <div class="selected-tab-body">
            <div v-for="event in currentEvents">
                <div class="shiur-row">
                    <div class="delete-section">
                        <div class="remove-section" v-on:click="deleteEvent(event)">
                            <font-awesome-icon class="remove-icon" :icon="['fal', 'trash-alt']" size="2x"/>
                        </div>
                    </div>
                    <div class="non-delete-section">
                        <div class="action-section" v-on:click="navigateToLesson(event.entry)">
                            <div class="play-section">
                                <font-awesome-icon class="play-icon" :icon="['fal', 'play-circle']" size="3x"/>
                            </div>
                            <div class="info-section">
                                <div class="shiur-title-section">{{event.entry.name}}</div>
                                <div class="shiur-length-section">
                                    <font-awesome-icon class="shiur-length-icon" :icon="['fal', 'clock']"/>
                                    {{event.entry.video ? event.entry.video.duration : NaN | duration}}
                                </div>
                            </div>
                            <div v-if="event.content && event.content.lessonTimestamp">
                                <div class="lesson-timestamp-container">
                                    <span class="lesson-timestamp">
                                        {{Math.round(event.content.lessonTimestamp) | duration}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="non-action-section">
                            <div class="download-section">
                                <span class="download-title">{{l10nDownload}}:</span>
                                <a class="download-option"
                                   v-bind:class="{'not-option': event.entry.audio === null}"
                                   :href="event.entry.audio?event.entry.audio.url:null" target="_blank">
                                    <font-awesome-icon class="download-section-icon" :icon="['fal', 'headphones']"/>
                                </a>
                                <a class="download-option"
                                   v-bind:class="{'not-option': event.entry.video === null}"
                                   :href="event.entry.video?event.entry.video.url:null" target="_blank">
                                    <font-awesome-icon class="download-section-icon" :icon="['fal', 'video']"/>
                                </a>
                                <a class="download-option last-download-option"
                                   v-bind:class="{'not-option': event.entry.pdf === null}"
                                   :href="event.entry.pdf?event.entry.pdf.url:null" target="_blank">
                                    <font-awesome-icon class="download-section-icon" :icon="['fal', 'print']"/>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        REMOVE_USER_EVENT,
        REMOVE_MANY_USER_EVENTS,
        ACTION_FAVORITE,
        ACTION_HISTORY,
    } from '../services/constants'
    import helpers from '../services/helpers'

    export default {
        name: 'user-data-component',
        data: function () {
            return {
                currentTabIndex: 0
            }
        },
        computed: {
            events() {
                return this.$store.state.userModule.events
            },
            favoriteEvents() {
                if (this.events.data) {
                    return this.events.data.filter(event => {
                        return event.action === ACTION_FAVORITE
                    })
                } else {
                    return null
                }
            },
            historyEvents() {
                if (this.events.data) {
                    return this.events.data.filter(event => {
                        return event.action === ACTION_HISTORY
                    })
                } else {
                    return null
                }
            },
            currentEvents() {
                switch (this.currentTabIndex) {
                    // case 0:
                    //     return this.favoriteEvents
                    case 1:
                        return this.historyEvents
                    default:
                        return this.favoriteEvents
                }
            },
            l10nFavorites() {
                return this.l10nGetter('favorites')
            },
            l10nHistory() {
                return this.l10nGetter('history')
            },
            l10nRemoveAllFromList() {
                return this.l10nGetter('remove_all_from_list')
            },
            l10nDownloadAll() {
                return this.l10nGetter('download_all')
            },
            l10nDownload() {
                return this.l10nGetter('download')
            },
        },
        methods: {
            deleteEvent(event) {
                this.$store.dispatch(REMOVE_USER_EVENT, event.id);
            },
            deleteAllCurrentEvents() {
                this.$store.dispatch(REMOVE_MANY_USER_EVENTS, this.currentEvents.map(event => {
                    return event.id
                }));
            },
            navigateToLesson: function (lesson) {
                this.$router.push({name: 'lesson', params: {id: lesson.id.toString()}})
            },
            setTabIndex(index) {
                this.currentTabIndex = index;
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .content {
        padding: 70px 245px 130px;
    }

    .tabs {
        display: flex;
        @include font-abraham(50px, $font-color-blue, 400);
        margin: 0 0 33px 0;
    }

    .tab {
        flex-grow: 1;
        &.favorites {
            margin: 0 17px 0 0;
        }
        &.history {
            margin: 0 0 0 17px;
        }
        padding: 0 0 25px 0;

        border-bottom: $grey-3 solid 8px;
        &.selected-tab {
            border-bottom: $accent-1 solid 8px;
        }

    }

    .tab-content {
        cursor: pointer;
    }

    .actions {
        display: flex;
        justify-content: space-between;
        @include font-abraham(18px, $grey-1, 300);
        margin: 0 0 40px 0;

    }

    .remove-all {
        cursor: pointer;
        line-height: 24px;
    }

    .remove-all-icon {
        margin: 0 18px 0 0;
    }

    .shiur-row {
        display: flex;
        border-top: $grey-3 solid 1px;
        padding: 20px 14px;
    }

    .delete-section {
        display: flex;
    }

    .non-delete-section {
        display: flex;
        flex-grow: 1;
        justify-content: space-between;
    }

    .lesson-timestamp-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 0 0 0 45px;
    }

    .lesson-timestamp {
        background: $accent-1;
        @include font-abraham(18px, white, 300);
        padding: 0 7px;
    }

    .action-section {
        display: flex;
        padding: 0 50px 0 0;
        cursor: pointer;

        &:hover {
            .play-icon, .shiur-title-section {
                color: $accent-1;
            }
        }
    }

    .remove-section {
        display: flex;
        align-items: center;
        padding: 0 34px 0 0;
        margin: 0 26px 0 0;
        border-right: $grey-3 solid 1px;
        cursor: pointer;

        .remove-icon {
            color: $grey-1;
        }

        &:hover {
            .remove-icon {
                color: $accent-1;
            }
        }

    }

    .play-icon {
        color: $font-color-blue;
        margin: 0 30px 0 0;
    }

    .shiur-title-section {
        @include font-abraham(26px, $font-color-blue, 400);
    }

    .shiur-length-section {
        display: flex;
        align-items: center;
        @include font-abraham(18px, $grey-1, 300);
    }

    .shiur-length-icon {
        margin: 0 12px 0 0;
    }

    .non-action-section {
        display: flex;
    }

    .download-section {
        display: flex;
        align-items: center;
        padding: 0 7px 0 24px;
        border-left: $grey-3 solid 1px;

    }

    .download-title {
        @include font-abraham(16px, $grey-1, 400);
        margin: 0 16px 0 0;
    }

    .download-option {
        cursor: pointer;
        text-decoration: none;
        &.not-option {
            cursor: not-allowed;
            @include font-abraham(14px, #c0c0c0, 100);
        }
        display: flex;
        align-items: center;
        @include font-abraham(14px, $grey-1, 100);
        margin: 0 21px 0 0;

        &.last-download-option {
            margin: 0;
        }
    }

    .download-section-icon {
        font-size: 24px;
        margin: 0 6px 0 0;
    }


</style>
